import { cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const inputBaseClass = cva(
  [
    "border",
    "px-5 py-3",
    "rounded-md",
    "text-base text-black placeholder-[#9CA3AF]",
    "block",
    "w-full",
    "focus:border-transparent",
  ],
  {
    variants: {
      error: {
        true: "border-red-500",
        false: "border-gray-300",
      },
      disabled: {
        true: "cursor-not-allowed opacity-50 bg-gray-50",
        false: "bg-white",
      },
      // Можно добавить дополнительные варианты стилей, если они вам нужны
    },
    defaultVariants: {
      error: false,
      disabled: false,
    },
  }
);

// Типы для пропсов компонента
type InputPropsType = {
  label?: string;
  placeholder?: string;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input: React.FC<InputPropsType> = ({ label, placeholder, helperText, error, disabled, ...props }) => {
  // Слияние классов с twmerge, применяя условные стили
  const inputClasses = inputBaseClass({ error, disabled });

  return (
    <>
      {label && (
        <label className={twMerge("font-medium mb-1", error ? "text-red-500" : "", disabled ? "text-gray-500" : "")}>
          {label}
        </label>
      )}
      <input
        type="text"
        className={twMerge(inputClasses)}
        placeholder={placeholder}
        aria-placeholder={placeholder}
        disabled={disabled}
        aria-invalid={error ? "true" : "false"}
        aria-describedby={helperText ? "helper-text" : undefined}
        {...props}
      />
      {helperText && (
        <p
          id="helper-text"
          className={twMerge("text-xs mt-1", error ? "text-red-500" : "", !error && !disabled ? "text-gray-500" : "")}
        >
          {helperText}
        </p>
      )}
    </>
  );
};

export default Input;

// Типы для пропсов компонента
type TextAreaProps = {
  label?: string;
  placeholder?: string;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextArea: React.FC<TextAreaProps> = ({ label, placeholder, helperText, error, disabled, ...props }) => {
  // const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  // useEffect(() => {
  //   const textarea = textareaRef.current;

  //   if (textarea) {
  //     // Функция для автоматического изменения высоты textarea
  //     const adjustHeight = () => {
  //       textarea.style.height = "auto";
  //       textarea.style.height = `${textarea.scrollHeight}px`;
  //     };

  //     // Устанавливаем высоту при монтировании компонента
  //     adjustHeight();

  //     // Добавляем обработчик событий для динамического изменения высоты
  //     textarea.addEventListener("input", adjustHeight);

  //     // Очистка обработчика событий при размонтировании
  //     return () => {
  //       textarea.removeEventListener("input", adjustHeight);
  //     };
  //   }
  // }, [textareaRef]);

  // Слияние классов с twmerge, применяя условные стили
  const inputClasses = inputBaseClass({ error, disabled });

  return (
    <>
      {label && (
        <label className={twMerge("font-medium mb-1", error ? "text-red-500" : "", disabled ? "text-gray-500" : "")}>
          {label}
        </label>
      )}
      <textarea
        className={twMerge(
          inputClasses,
          "min-h-[49px]",
          "scrollbar-thin scrollbar-thumb-rounded-lg scrollbar-w-2 scrollbar-thumb-[#D1D5DB]"
        )} // Отключаем изменение размера вручную и скрываем полосу прокрутки
        placeholder={placeholder}
        aria-placeholder={placeholder}
        disabled={disabled}
        aria-invalid={error ? "true" : "false"}
        aria-describedby={helperText ? "helper-text" : undefined}
        {...props}
      />
      {helperText && (
        <p
          id="helper-text"
          className={twMerge("text-xs mt-1", error ? "text-red-500" : "", !error && !disabled ? "text-gray-500" : "")}
        >
          {helperText}
        </p>
      )}
    </>
  );
};
